import mapPeCompanyDetailFromApi from 'rtkQuery/sharespro/mapper/modules/pe/peCompany/mapPeCompanyDetailFromApi';
import mapChartDataFromApi from 'rtkQuery/sharespro/mapper/shared/mapChartDataFromApi';

const mapPeCompanyOrderDetailFromApi = (
  resp: ApiPeCompanyOrderDetail
): PeCompanyOrderDetail => {
  return {
    id: resp.id,
    company: mapPeCompanyDetailFromApi(resp.company),
    chartData: mapChartDataFromApi(resp.chart),
    price: resp.price,
    quantity: resp.quantity,
  };
};

export default mapPeCompanyOrderDetailFromApi;
